import { freshMachineSignal } from "../../../shared/production/machine-signal";
export function machineStatePresentation(counter: { configured: boolean; machineRunning?: boolean | null; machineMeasuredAt?: string | null } | null, unavailable: boolean, now = Date.now()) {
  const running = !unavailable && counter?.configured ? freshMachineSignal(counter.machineRunning,counter.machineMeasuredAt,now) : null;
  return {running,label:running===false ? "Makine duruşta" : running===true ? "Makine çalışıyor" : "Makine durumu doğrulanamadı"};
}
